import { Close, SaveAs } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";

const styles = {
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "600px",
    maxHeight: "fit-content",
    minHeight: "fit-content",
    overflowY: "auto",
    borderRadius: "8px",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  boxHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    mb: 1,
  },
  boxTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    color: "primary.main",
    width: "100%",
  },
  boxRowFields: {
    display: "flex",
    flexDirection: "column",
    with: "100%",
    gap: 0.5,
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: 500,
    color: "text.primary",
  },
};
const HostDescriptionModal = ({
  open = false,
  onClose = () => {},
  onSave = () => {},
  hostData,
  setEditingHostData,
  loading,
}) => {
  const [description, setDescription] = useState(false);

  const initializeForm = useCallback(() => {
    setDescription(hostData?.descricao || "");
  }, [hostData]);

  useEffect(() => {
    if (open) {
      initializeForm();
    }
  }, [open]);

  const handleChange = (e) => {
    const { value } = e.target;
    setDescription(value);
  };

  const handleClose = () => {
    setEditingHostData(null);
    onClose();
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Paper sx={styles.paper}>
          <>
            <Box sx={styles.boxHeader}>
              <Box sx={styles.boxTitle}>
                <SaveAs
                  sx={{ color: "primary.main", mr: 0.5 }}
                  fontSize="medium"
                />

                <Typography fontWeight={500}>
                  Editar Descrição do Host
                </Typography>
              </Box>
              <IconButton aria-label="close" onClick={handleClose}>
                <Close />
              </IconButton>
            </Box>
            <Divider sx={{ mb: 2 }} />
          </>
          <Box sx={styles.boxRowFields}>
            <Typography sx={styles.subtitle}>Descrição</Typography>{" "}
            <TextField
              fullWidth
              placeholder="Descrição do Host"
              name="descricao"
              value={description}
              onChange={handleChange}
              autoComplete="off"
              size="small"
              multiline
              rows={4}
              inputProps={{ maxLength: 150 }}
              helperText="Limite de 255 dígitos"
              disabled={loading}
            />
          </Box>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Stack
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <Button variant="text" onClick={handleClose} size="small">
                Cancelar
              </Button>
              <LoadingButton
                loading={loading}
                variant="contained"
                size="medium"
                onClick={() => {
                  onSave(
                    {
                      hostId: hostData?.id,
                      nome: hostData?.nome,
                      description: description,
                    },
                    hostData,
                  );
                }}
                disabled={loading}
                startIcon={<SaveAs />}
              >
                Atualizar
              </LoadingButton>
            </Stack>
          </Stack>
        </Paper>
      </Modal>
    </>
  );
};

export default HostDescriptionModal;
